import IConfig from './IConfig';

let Config: IConfig = null;

export const setConfig = (config: IConfig): void => {
  Config = { ...config };
};

export const getConfig = (key: keyof IConfig): string => Config?.[key];
